<div
  class="text-xs text-white mb-0.5 w-full absolute left-0 text-center bottom-0"
>
  Copyright 2019-{{ currentYear }}© All Rights Reserved.
  <a
    href="https://konnecta.io/"
    target="_blank"
    class="font-bold text-white hover:text-white text-inherit"
  >
    Konnecta Systems
  </a>
</div>
